import axios from "axios";
import config from "../../config/config";
import { buildAuthHeaders, buildAuthRequestConfig } from "../../utils/authSession";

function authHeaders() {
  return buildAuthHeaders();
}

export async function loadApplicantMessagingWorkspace() {
  const response = await axios.get(
    `${config.API_BASE_URL}/api/applicant/messages/workspace`,
    {
      ...buildAuthRequestConfig({ headers: authHeaders() }),
    }
  );
  return response.data || {};
}

export async function updateApplicantMessageState(payload) {
  const response = await axios.patch(
    `${config.API_BASE_URL}/api/applicant/messages/state`,
    payload,
    {
      ...buildAuthRequestConfig({ headers: authHeaders() }),
    }
  );
  return response.data || {};
}
